import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AlertService } from '../../alert';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-container',
  providers: [StorageService],
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.css']
})
export class ContainerComponent implements OnInit {

  loading = false;
  container: any  = {};

  constructor(
    private storageService: StorageService,
    private route: ActivatedRoute,
    private alertService: AlertService) { }

  ngOnInit() {
    let reference = this.route.snapshot.params['id'];
    if (reference == "new") {
      this.container.containerStatus = "OPEN";
      this.container.containerType = "";
    } else {
      // do nothing
    }
  }

  save() {
    this.loading = true;
    this.storageService.updateContainer(this.container, false)
      .subscribe(
        data => {
          this.alertService.success("Lagerplatz erfolgreich gespeichert");
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/storage-place/container/container.component.ts